import React, { useRef } from "react";
import Table from "react-bootstrap/Table";
import { Bar } from "react-chartjs-2";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
const utahData = "/img/headerlogo.png";
const kpi = "/img/KPI-DASH 2.png";
const bodex = "/img/bodexLogo.png";
const pdf = "/img/pdf1.png";

const AeroTable5 = ({ apiData }) => {
  const pdfRef = useRef(); // Ref for capturing PDF content

  if (!apiData || apiData.length === 0) {
    return <p>No data available for Female's Employment Trend.</p>;
  }

  // Extracting years and employment counts for the chart
  const years = apiData.map((item) => item.year);
  const femaleCounts = apiData.map((item) => parseInt(item.female, 10));

  // Chart data configuration
  const chartData = {
    labels: years,
    datasets: [
      {
        label: "Female Employment Count",
        data: femaleCounts,
        backgroundColor: "rgba(170, 0, 0)",
        borderColor: "rgba(255, 99, 132, 1)",
        borderWidth: 1,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: true,
        text: 'Female Employment Trend (2018-2024)',
        font: {
          size: 14,
          weight: 'bold'
        },
        padding: { top: 10, bottom: 10 }
      },
      legend: {
        display: true,
        position: "top",
        labels: {
          font: { size: 11 },
          boxWidth: 12,
          padding: 10
        }
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Year",
        },
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Employment Count",
        },
      },
    },
  };

  // PDF Generation function
  const downloadPDF = () => {
    const input = pdfRef.current;
    const originalWidth = input.style.width;
    input.style.width = "1100px"; // Temporarily increase width for better PDF capture

    html2canvas(input, { scale: 3 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      // Add header and footer
      // Header
      pdf.addImage(utahData, "PNG", 60, 10, 32, 16); // Logo
      pdf.setFontSize(26);
      pdf.text("UTahData.org", 95, 22);
      pdf.link(50, 15, 60, 10, { url: "https://utahdata.org" });

      pdf.setFontSize(12);
      pdf.setLineWidth(0.5);
      pdf.line(10, 35, 200, 35); // Line after header

      // Add main content
      const headerHeight = 38;
      pdf.addImage(imgData, "PNG", 5, headerHeight, imgWidth, imgHeight);

      // Footer
      pdf.line(10, 260, 200, 260); // Line before footer
      const footerStartY = 265;
      //  pdf.addImage(utahData, "PNG", 22, 265, 30, 15);
      pdf.addImage(utahData, "PNG", 22, 265, 30, 15);
      pdf.setFontSize(10);
      pdf.setTextColor(0, 122, 255);
      pdf.text("Built by", 55, footerStartY + 10);
      pdf.addImage(bodex, "PNG", 68, footerStartY + 4, 44, 10);
      pdf.text("using", 112, footerStartY + 10);
      pdf.addImage(kpi, "PNG", 125, footerStartY, 20, 20);
      pdf.text(" 20250916.v3.198", 148, footerStartY + 10);

      // Date and URL
      const currentDate = new Date().toLocaleDateString();
      pdf.setFontSize(10);
      pdf.text(`Downloaded on: ${currentDate}`, 150, 295);
      const currentURL = window.location.href;
      pdf.text(`Downloaded from: ${currentURL}`, 10, 295);

      pdf.save("female-employment-trend.pdf");
      input.style.width = originalWidth; // Reset width
    });
  };

  // Calculate summary metrics
  const currentFemale = femaleCounts[femaleCounts.length - 1];
  const initialFemale = femaleCounts[0];
  const growthPercent = ((currentFemale - initialFemale) / initialFemale * 100).toFixed(1);
  
  // Find year with highest female employment
  let maxFemale = 0;
  let peakYear = years[0];
  femaleCounts.forEach((count, index) => {
    if (count > maxFemale) {
      maxFemale = count;
      peakYear = years[index];
    }
  });

  // Find year with highest growth
  let maxGrowth = 0;
  let bestGrowthYear = years[0];
  for (let i = 1; i < femaleCounts.length; i++) {
    const currentValue = femaleCounts[i];
    const prevValue = femaleCounts[i-1];
    const growth = ((currentValue - prevValue) / prevValue) * 100;
    if (growth > maxGrowth) {
      maxGrowth = growth;
      bestGrowthYear = years[i];
    }
  }

  return (
    <div className="w-full p-4">
      <div ref={pdfRef} className="content-to-export p-3 sm:p-4 bg-gradient-to-br from-pink-50 to-white rounded-xl shadow-lg w-full max-w-full overflow-hidden">
        <h3 className="text-xl sm:text-2xl font-bold mb-4 text-center text-gray-800">Female Employment Trend (2018-2024)</h3>

        {/* Summary Cards */}
        <div className="grid grid-cols-3 gap-3 mb-4 text-center">
          <div className="p-3 bg-pink-100 rounded-lg shadow-sm">
            <p className="text-xs font-medium text-gray-600 mb-1">
              Female Growth Since 2018
            </p>
            <p className="text-lg font-bold text-pink-800">+{growthPercent}%</p>
          </div>
          <div className="p-3 bg-green-100 rounded-lg shadow-sm">
            <p className="text-xs font-medium text-gray-600 mb-1">
              Peak Female Employment
            </p>
            <p className="text-lg font-bold text-green-800">{peakYear}</p>
          </div>
          <div className="p-3 bg-purple-100 rounded-lg shadow-sm">
            <p className="text-xs font-medium text-gray-600 mb-1">2024 Female Employment</p>
            <p className="text-lg font-bold text-purple-800">
              {currentFemale.toLocaleString()} 👩‍💼
            </p>
          </div>
        </div>

        {/* Additional Metrics */}
        <div className="grid grid-cols-2 gap-3 mb-4 text-center">
          <div className="p-3 bg-yellow-100 rounded-lg shadow-sm">
            <p className="text-xs font-medium text-gray-600 mb-1">Best Growth Year</p>
            <p className="text-lg font-bold text-yellow-800">{bestGrowthYear} (+{maxGrowth.toFixed(1)}%)</p>
          </div>
          <div className="p-3 bg-indigo-100 rounded-lg shadow-sm">
            <p className="text-xs font-medium text-gray-600 mb-1">Peak Female Employment</p>
            <p className="text-lg font-bold text-indigo-800">{maxFemale.toLocaleString()}</p>
          </div>
        </div>

        {/* Table + Chart Side-by-Side Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-6">
          {/* Table */}
          <div className="w-full">
            <div className="overflow-x-auto">
              <Table striped bordered hover responsive className="w-full border-collapse text-center shadow-sm rounded-lg overflow-hidden">
                <thead className="bg-gray-800 text-white">
                  <tr>
                    <th className="p-2 text-sm">Year</th>
                    <th className="p-2 text-sm">Female Employment Count</th>
                  </tr>
                </thead>
                <tbody>
                  {apiData.map((row, index) => (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="p-2 text-sm">{row.year}</td>
                      <td className="p-2 text-sm">{parseInt(row.female).toLocaleString()}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>

          {/* Chart */}
          <div className="w-full">
            <div className="bg-white rounded-lg shadow-sm p-3">
              <div className="overflow-x-auto">
                <div className="relative" style={{ height: '350px', minHeight: '280px', minWidth: '400px' }}>
                  <Bar data={chartData} options={chartOptions} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Download PDF Button */}
      <div className="flex justify-center mt-4">
        <button
          onClick={downloadPDF}
          className="download-btn bg-red-700 hover:bg-red-900 px-4 py-2 text-white rounded-lg flex items-center gap-2 shadow-lg text-sm"
        >
          <span>Download as PDF</span>
          <img className="w-[1.2rem]" src={pdf} alt="PDF Icon" />
        </button>
      </div>
    </div>
  );
};

export default AeroTable5;
